import React, { Fragment, useEffect, useRef, useState } from "react";
import moment from "moment";
import { Route } from "react-router-dom";
import { bool, func, object } from "prop-types";
import { connect } from "react-redux";
import * as style from "./styles.module.scss";
import { downloadAssignmentDetails } from "../ResourceFolders/util";
import Feedback from "../../components/CandidateFeedback/Feedback";
import Header from "../../components/Header";
import history from "../../history";

import {
  updateUserInProfileSilent,
  userAttemptLogout,
  postIpnForm,
  updateGeneralConsent,
  updateDetailsStoreDate,
} from "../../redux/actions";

import { isMobile, statusCodes } from "../../helpers";
import {
  get as getCookie,
  remove as removeCookie,
} from "../../helpers/cookies";

import Checkbox from "../../common/Checkbox/index";
import { Button } from "../../common";
import ProfileSection from "../../components/profile/ProfileSection";
import ProfileItem from "../../components/profile/ProfileItem";
import TimesheetsProfileSection from "../../components/AdminSections/TimesheetsProfileSection";
import PayslipsProfileSection from "../../components/AdminSections/PayslipsProfileSection";
import AssignmentDetails from "../../components/AdminSections/Downloads/AssignmentDetails";
import KID from "../../components/AdminSections/Downloads/KID";
import BookingsProfileSection from "../../components/BookingsProfileSection";
import HolidayProfileSection from "../../components/AdminSections/HolidayProfileSection/index";
import FindJobSection from "../../components/FindJobSection";
import { refreshSections } from "../../redux/actions/onboardActions";
import CvPopup from "../../components/CvPopup";
import CvUploadContainer from "../CvUploadContainer";
import BranchDetails from "../../components/BranchDetails";
import LocalJobs from "../../components/LocalJobs/index.tsx";
import Documentation from "../Documentation/Documentation";
import ProfileImage from "../../components/ProfileImage";
import IpnContainer from "../IpnOnboarding";
import CandidateProfileSection from "../../components/AdminSections/CandidateProfileSection";
import CandidateJobSection from "../../components/AdminSections/CandidateJobSection";
import ShiftsProfileSection from "../../components/AdminSections/ShiftsProfileSection";

export const getSortedSections = (appData, popupSectionsOpenSetters) => {
  const COMPLETED_STATUS = statusCodes.COMPLETED.status;
  const sections = appData.sections.map((section) => {
    if (section.taskName === "ContractForServices") {
      return {
        ...section,
        onClick: () => {
          document.location.href = "/my-account/contract-for-services";
        },
      };
    }
    if (!section.isPopupOnMobile) {
      return section;
    }
    return {
      ...section,
      onClick: isMobile
        ? () =>
            history.push(`/profile/edit/${section.link || section.taskName}`)
        : () => popupSectionsOpenSetters[section.taskName](true),
    };
  });

  const { responsibleTeam } = appData;

  const isEducation =
    responsibleTeam === "HEDH" ||
    responsibleTeam === "HEDC" ||
    responsibleTeam === "HEDE";

  const reorderUnfilledEducationSections = (unfilled) => {
    const order = {
      // education reorder ~ ticket 2446
      17: 0,
      1: 1,
      4: 2,
      9: 3,
      7: 4,
      8: 5,
      2: 6,
      3: 7,
      6: 8,
      13: 9,
      14: 10,
      12: 11,
      11: 12,
      32: 13,
      40: 14,
    };

    const reordered = [];

    unfilled.forEach((c) => {
      reordered[order[c.id]] = c;
    });

    return reordered.filter((cur) => cur); // remove undefined values (dependent on how many unfilled sections cand acc has)
  };

  const unfilled =
    sections &&
    sections.filter(
      (section) =>
        section.status !== COMPLETED_STATUS &&
        section.isHidden !== true &&
        section.status !== statusCodes.CONTINUAL.status
    );

  const unfilledSections = isEducation
    ? reorderUnfilledEducationSections(unfilled)
    : unfilled;

  const filledSections =
    sections &&
    sections.filter(
      (x) =>
        !unfilledSections.includes(x) &&
        x.taskName !== "Timesheets" &&
        x.taskName !== "Bookings"
    );

  const timesheetsSection =
    sections && sections.find((e) => e.taskName === "Timesheets");
  const bookingsSection =
    sections && sections.find((e) => e.taskName === "Bookings");
  const payslipsSection =
    sections && sections.find((e) => e.taskName === "Payslips");
  const holidaySection =
    sections && sections.find((e) => e.taskName === "Holiday");

  const shiftsSection =
    sections && sections.find((e) => e.taskName === "Shifts");

  let newFilledSections;
  let newUnfilledSections;

  if (appData.permWorkSeeking && !appData.tempWorkSeeking) {
    // hide RTW (section id 4) for perm only candidates - 2615
    newFilledSections = filledSections.filter(({ id }) => id !== 4);
    newUnfilledSections = unfilledSections.filter(({ id }) => id !== 4);
  }

  return {
    filledSections: newFilledSections || filledSections,
    unfilledSections: newUnfilledSections || unfilledSections,
    timesheetsSection,
    shiftsSection,
    bookingsSection,
    payslipsSection,
    holidaySection,
  };
};

const onAddOrUpdateHandler = (sectionName, link = false) => {
  history.push(`/profile/edit/${link || sectionName}`);
};

const Profile = ({
  loading,
  appData,
  updateProfile,
  auth,
  triggerSectionRefresh,
  updateDetailsSubmitDate,
  generalConsent,
  logout,
  postForm,
  ipnLoading,
}) => {
  const [isCvOpen, setCvOpen] = useState(false);

  const [isProfileImageOpen, setProfileImageOpen] = useState(false);
  useEffect(() => {
    if (
      !loading &&
      appData &&
      getCookie("shouldSendBranchNotificationV2") === "true"
    ) {
      removeCookie("shouldSendBranchNotificationV2");
    }
    triggerSectionRefresh();
  }, []);
  const {
    candidateRef,
    emailAddress,
    candidateJobs,
    compliant,
    permissions,
    createdAt,
    contractForServicesHandling,
  } = appData;

  const createdDate = moment(createdAt).format("YYYY-MM-DD");

  const contractForServicesStartDate = "2021-09-01";
  // ignore account created at date if permissions are ticked
  const forceShowCFS =
    permissions &&
    (permissions.contractForServicesRecruitment ||
      permissions.contractForServicesDriving);

  const acceptTermsOfUse = {
    candidateRef,
    emailAddress,
    acceptTermsOfUse: true,
  };

  const submitGeneralConsent = async () => {
    await generalConsent();
  };

  const handleAcceptTermsOfUse = async () => {
    await updateProfile(candidateRef, acceptTermsOfUse);
  };

  const popupSectionsOpenSetters = {
    Cv: setCvOpen,
    ProfileImage: setProfileImageOpen,
  };

  const {
    unfilledSections,
    filledSections,
    timesheetsSection,
    shiftsSection,
    bookingsSection,
    payslipsSection,
  } =
    appData &&
    appData.sections &&
    getSortedSections(appData, popupSectionsOpenSetters);

  const sections = unfilledSections
    .map((elem) => ({ ...elem, redOutline: true }))
    .concat(filledSections);

  const [onboardChecked, setOnBoardChecked] = useState(appData.generalConsent);
  const toggleOnboardCheck = () => setOnBoardChecked(!onboardChecked);
  const [showPrompt, setShowPrompt] = useState(false);

  const sectionsRef = useRef(null);

  const addTopMarginOnDesktopWhenFindJobIsFirst =
    unfilledSections.length === 0 &&
    timesheetsSection.isHidden &&
    bookingsSection.isHidden
      ? "mt-lg-4"
      : "";

  const { address } = appData;

  const details = [
    appData.mobileTelephone ? appData.mobileTelephone : "",
    address ? address.addressLine1 : "",
    address ? address.town : "",
    address ? address.county : "",
    address ? address.postcode : "",
  ];

  const updateDetailsLables = [
    "Mobile Telephone",
    "Address line 1",
    "Town",
    "County",
    "Postcode",
  ];

  const handleLogout = () => {
    logout();
    document.location.href = "/my-account/log-out";
  };

  const updateDetailsText = () => {
    return details.map((cur, i) => {
      return (
        <div key={cur} style={{ backgroundColor: "white" }}>
          <span>{updateDetailsLables[i]}</span>
          <input
            className="register_field form-control"
            style={{ width: "40%", marginBottom: "15px" }}
            value={cur}
            type="text"
            disabled={true}
          />
        </div>
      );
    });
  };

  const showUpdateDetails = () => {
    const dateAccCreated = new Date(appData.createdAt);
    const curDate = new Date();

    const date3MonthsAgo = curDate;
    date3MonthsAgo.setMonth(curDate.getMonth() - 3);

    if (!appData.updateDetailsDate) {
      setShowPrompt(dateAccCreated < date3MonthsAgo);
      return dateAccCreated < date3MonthsAgo; // 3 months since acc creation?
    }
    const updateDetailsDate = new Date(appData.updateDetailsDate);
    if (updateDetailsDate < date3MonthsAgo) setShowPrompt(true);
    return updateDetailsDate < date3MonthsAgo; // has it been 3 months since last prompt?
  };

  const handleUpdatePrompt = (answer) => {
    updateDetailsSubmitDate();
    setShowPrompt(false);
    return answer
      ? history.push("/profile")
      : history.push("/profile/edit/BasicInfo");
  };

  const handleAssignmentDetails = () => downloadAssignmentDetails();

  const accountCreated = moment(appData.createdAt).format("YYYY-MM-DD");
  const showTermsOfUse = moment(accountCreated).isBefore("2022-08-18"); // this date is determined by the date when terms of use for new candidates where deployed to production

  useEffect(() => {
    showUpdateDetails();
  }, [showPrompt]);

  const { YASI } = appData.assignmentDetails;
  const showKID = moment(accountCreated).isAfter("2020-04-06");
  const [closeFeedback, setCloseFeedback] = useState(false);
  const { showSurvey } = appData.surveyData;
  const { isIpn } = appData.permissions;

  return (
    <Fragment>
      <CvUploadContainer>
        {(cvProps) => (
          <CvPopup isOpen={isCvOpen} setOpen={setCvOpen} {...cvProps} />
        )}
      </CvUploadContainer>
      <Route path="/profile/edit/Documentation" component={Documentation} />
      <ProfileImage isOpen={isProfileImageOpen} setOpen={setProfileImageOpen} />
      {showPrompt && !auth.isLoading && (
        <div className={`p-hf ${style.updateDetails__wrapper}`}>
          <div className={`${style.updateDetails} p-2 `}>
            <h2 className="mb-2">
              Please confirm that the details we have for you are still correct
            </h2>
            {updateDetailsText()}
            <div style={{ display: "flex", flexDirection: "column" }}>
              <Button
                classes="btn btn-primary mt-2"
                onClick={() => handleUpdatePrompt(true)}
              >
                Yes, those details are correct
              </Button>
              <Button
                classes="btn btn-primary mt-2"
                onClick={() => handleUpdatePrompt(false)}
              >
                No, those details need to be updated
              </Button>
            </div>
          </div>
        </div>
      )}
      {!appData.generalConsent && !auth.isLoading && (
        <Fragment>
          <div className={`${style.generalConsentModal__wrapper}`}>
            <div className={`${style.generalConsentModal} p-1 pb-5`}>
              <h2 className={style.generalConsentModal__title}>
                Just one more thing
              </h2>
              <h5 className={style.generalConsentModal__subtitle}>
                Please read the declaration and select the checkbox to confirm
              </h5>
              <div className={style.generalConsentModal__description}>
                <p>
                  I consent that I have answered all questions correctly and
                  honestly and I understand that failure to disclose the
                  relevant information may result in termination of my
                  assignment.{" "}
                </p>
                <p>
                  {" "}
                  I have read the Privacy Policy and understand that my personal
                  data will be forwarded to employers and third parties in order
                  for you to obtain references, in order to provide me with
                  work, payroll services and to comply with any internal and
                  external audit requirements.{" "}
                </p>
                <p>
                  I also consent to HRGO Recruitment checking my DBS status
                  online and manually, carrying out a DBS check where relevant,
                  obtaining the result electronically and for HRGO to receive
                  the DBS certificate directly.
                </p>
                <p>
                  I agree that HRGO Recruitment will deduct monies from my pay
                  to recover any accidental overpayment.
                </p>
                <p>
                  I am aware the HRGO Recruitment Temporary Worker’s Handbook is
                  available online and that it is my responsibility to adhere to
                  the policies it contains, including timesheet deadlines.
                </p>
                <p>
                  I understand that I must treat all information relating to any
                  clients or HRGO as confidential and that failure to do so may
                  be in breach of GDPR 2018 and my contract, and could result in
                  the termination of my assignment.
                </p>
                <p>
                  I will seek advice from my consultant if there is anything I
                  do not understand.
                </p>
              </div>
              <Checkbox
                classes="my-2"
                label="I confirm the above statement"
                isChecked={onboardChecked}
                onClick={toggleOnboardCheck}
              />
              <div className="w-100 d-flex flex-row-reverse">
                <Button
                  classes="btn btn-primary mt-2 mb-4"
                  disabled={!onboardChecked}
                  onClick={submitGeneralConsent}
                >
                  Next
                </Button>
              </div>
            </div>
          </div>
        </Fragment>
      )}
      <div className="d-flex">
        <div className="flex-grow-1 w-100">
          {appData && appData.sections && !auth.isLoading && (
            <div className="onboardProfile overFlow_x-hidden">
              {!appData.acceptTermsOfUse && !auth.isLoading && showTermsOfUse && (
                <div className={`${style.generalConsentModal__wrapper}`}>
                  <div className={`${style.generalConsentModal} p-1 pb-5`}>
                    <h2
                      style={{ display: "flex", justifyContent: "center" }}
                      className="mb-2"
                    >
                      Candidate Account Terms of Use
                    </h2>
                    <p>
                      By clicking Accept, I confirm that I have read and
                      understood the
                      <br />
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href={
                          "https://www.hrgo.co.uk/media/7869/candidate-hr-go-portal-terms-of-use-june-2022.pdf"
                        }
                      >
                        {" "}
                        Candidate Account Terms of Use.
                      </a>
                    </p>
                    <p>
                      If you do not agree to the terms, please contact
                      <br />
                      <a href="mailto:customer.success@hrgo.co.uk">
                        {" "}
                        customer.success@hrgo.co.uk{" "}
                      </a>
                      and select the Back option.
                    </p>
                    <div
                      style={{
                        marginTop: "1rem",
                        justifyContent: "space-between",
                      }}
                      className="w-100 d-flex"
                    >
                      <Button
                        classes="btn btn-secondary mt-2 mb-4"
                        onClick={handleLogout}
                      >
                        <a>Back</a>
                      </Button>
                      <Button
                        classes="btn btn-primary mt-2 mb-4"
                        onClick={handleAcceptTermsOfUse}
                      >
                        Accept
                      </Button>
                    </div>
                  </div>
                </div>
              )}
              {!closeFeedback && showSurvey && (
                <Feedback
                  setCloseFeedback={setCloseFeedback}
                  closeFeedback={closeFeedback}
                />
              )}
              <ProfileSection titleText="">
                <div className={`${style.admin_grid}`}>
                  <CandidateProfileSection appData={appData} />
                </div>
              </ProfileSection>
              {candidateJobs.length > 0 && (
                <ProfileSection titleText="Your jobs">
                  <div className={`${style.admin_grid}`}>
                    {candidateJobs.map((job, index) => (
                      <div
                        key={index}
                        className={`${style.profile__job} bg-white rounded d-flex flex-column text-left shadow`}
                        id="candidateJobsSection"
                      >
                        <CandidateJobSection appData={appData} job={job} />
                      </div>
                    ))}
                  </div>
                </ProfileSection>
              )}
              <div className={"d-block d-lg-none w-100 bg-grey container"}>
                {unfilledSections.length <= 3 ? (
                  unfilledSections.map((section) => (
                    <div className="my-1" key={section.id}>
                      <ProfileItem
                        id="profileSectionsMobileTop"
                        onAddOrUpdate={onAddOrUpdateHandler}
                        item={section}
                        isIncomplete
                      />
                    </div>
                  ))
                ) : (
                  <Fragment>
                    <ProfileItem
                      id="profileSectionsMobileSummary"
                      onAddOrUpdate={() =>
                        sectionsRef.current.scrollIntoView({
                          behavior: "smooth",
                        })
                      }
                      item={{
                        name: `You have ${unfilledSections.length} incomplete items`,
                      }}
                      isIncomplete
                      customText="View incomplete"
                    />
                  </Fragment>
                )}
              </div>
              <div className="container px-0 px-lg-1 d-lg-block d-none">
                <div className="row">
                  {unfilledSections && unfilledSections.length > 0 && (
                    <ProfileSection
                      id="profileSectionsDesktop"
                      titleText={"Complete your account"}
                      sections={unfilledSections}
                      onAddOrUpdate={onAddOrUpdateHandler}
                      isIncomplete
                    />
                  )}
                </div>
              </div>
              {isIpn && (
                <IpnContainer
                  postForm={postForm}
                  ipnLoading={ipnLoading}
                  appData={appData}
                />
              )}
              {!bookingsSection.isHidden && (
                <ProfileSection titleText={"Your bookings"}>
                  <BookingsProfileSection
                    onAddOrUpdateHandler={onAddOrUpdateHandler}
                    bookingsSection={bookingsSection}
                  />
                </ProfileSection>
              )}
              {(!timesheetsSection.isHidden ||
                !bookingsSection.isHidden ||
                !payslipsSection.isHidden) && (
                <ProfileSection titleText={"Your admin"}>
                  <div className={`mt-2 ${style.admin_grid}`}>
                    <ShiftsProfileSection
                      onAddOrUpdateHandler={onAddOrUpdateHandler}
                      shiftsSection={shiftsSection}
                    />
                    {!timesheetsSection.isHidden && (
                      <TimesheetsProfileSection
                        onAddOrUpdateHandler={onAddOrUpdateHandler}
                        timesheetsSection={timesheetsSection}
                      />
                    )}
                    {!payslipsSection.isHidden && (
                      <Fragment>
                        <PayslipsProfileSection
                          onAddOrUpdateHandler={onAddOrUpdateHandler}
                          payslipsSection={payslipsSection}
                        />
                        <HolidayProfileSection
                          onAddOrUpdateHandler={onAddOrUpdateHandler}
                        />
                      </Fragment>
                    )}
                  </div>
                </ProfileSection>
              )}
              {(showKID || YASI) && (
                <ProfileSection titleText={"Your downloads"}>
                  <div className={`${style.admin_grid}`}>
                    {showKID && (
                      <KID
                        onClick={() =>
                          history.push("/profile/edit/resources/HR_GO")
                        }
                      />
                    )}
                    {YASI && (
                      <AssignmentDetails onClick={handleAssignmentDetails} />
                    )}
                  </div>
                </ProfileSection>
              )}
              <ProfileSection
                className={addTopMarginOnDesktopWhenFindJobIsFirst}
              >
                <FindJobSection />
              </ProfileSection>
              <div className="container px-0 px-lg-1 d-lg-block d-none">
                <div className="row">
                  {filledSections && filledSections.length > 0 && (
                    <ProfileSection
                      id="profileSectionsDesktop"
                      titleText="Your details and information"
                      sections={filledSections.filter(
                        (s) => s.name !== "Payslips" || s.name !== "Shifts"
                      )}
                      onAddOrUpdate={onAddOrUpdateHandler}
                    />
                  )}
                </div>
              </div>
              <div className="container px-0 px-lg-1 d-block d-lg-none">
                <div ref={sectionsRef}>
                  <ProfileSection
                    id="profileSectionsMobile"
                    titleText="Your details and information"
                    sections={sections.filter(
                      (s) => s.name !== "Payslips" || s.name !== "Shifts"
                    )}
                    onAddOrUpdate={onAddOrUpdateHandler}
                  />
                </div>
              </div>
            </div>
          )}
          <BranchDetails />
          <LocalJobs />
        </div>
      </div>
    </Fragment>
  );
};
Profile.propTypes = {
  loading: bool.isRequired,
  appData: object.isRequired,
  updateDetailsSubmitDate: func,
  generalConsent: func.isRequired,
  updateProfile: func.isRequired,
  auth: object,
  triggerSectionRefresh: func,
};

const mapStateToProps = (state) => ({
  appData: state.core.app,
  auth: state.core.auth,
  loading: state.core.loading,
  ipnLoading: state.core.ipnOnboarding.isIpnLoading,
});

const mapDispatchToProps = {
  logout: userAttemptLogout,
  updateProfile: updateUserInProfileSilent,
  triggerSectionRefresh: refreshSections,
  updateDetailsSubmitDate: updateDetailsStoreDate,
  postForm: postIpnForm,
  generalConsent: updateGeneralConsent,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(Profile);
